<form [formGroup]="signUpStepOne" id="register-step-1">
  <h1 class="headingtitle text-left">
    {{ 'registrationStepOne.createanAccount1' | translate }}<br>
    <div class="hide-below-992">
      <span class="step_2">{{ 'registrationStepOne.createanAccount2' | translate }}</span>
      <span class="step_3">{{ 'registrationStepOne.createanAccount3' | translate }}</span>
    </div>
  </h1>
  <!-- <h3 class="subheadding">{{ 'registrationStepOne.getUptoCashback' | translate }}</h3> -->
  <div class="main_register col-md-12">
    <!-- email -->
    <div class="row no-margin">
      <div class="custom_padding col-sm-12">
        <div class="form-group" [ngClass]="getFormFiledClass('emailId',signUpStepOne, isSubmitted)">
          <div class="controls">
            <input type="email" autocomplete="email" autocapitalize="off" formControlName="emailId" name="email"
              class="floatLabel form-control" (focus)="onFocusForElement('emailId')" (focusout)="onFocusOutForElement()"
              id="email" maxlength="64" />
            <label for="email">{{ 'registrationStepOne.emailAddress' | translate }}</label>
          </div>
          <div class="arrow_box "
            *ngIf="getFormFiledClass('emailId',signUpStepOne, isSubmitted) && shouldShowErrors('emailId',signUpStepOne) && (signUpStepOne.controls['emailId'].value || isSubmitted)">
            {{getErrorMessage('emailId',signUpStepOne)}} </div>
        </div>
      </div>
    </div>

    <div class="row no-margin">
      <div class="custom_padding  col-sm-12 ">
        <!-- password -->
        <div class="form-group" [ngClass]="getFormFiledClass('pwd',signUpStepOne, isSubmitted)">
          <div class="controls passwrd">
            <input autocomplete="new-password" [type]="viewPassword ? 'text' : 'password'" formControlName="pwd"
              name="pwd" id="pwd" class="floatLabel form-control pwdFloatLabel" (input)="trimPassword()"
              (focus)="onFocusForElement('pwd')" (focusout)="onFocusOutForElement()" />
            <label for="pwd">{{ 'registrationStepOne.password' | translate }}</label>
          </div>
          <span class="pwd-show" [ngClass]="viewPassword ? 'eyeshow' : ''" (click)="viewPassword = !viewPassword"><i
              class="icon-icon-eye"></i></span>
          <div 
            *ngIf="getFormFiledClass('pwd',signUpStepOne, isSubmitted) && shouldShowPwdError('pwd',signUpStepOne) && (signUpStepOne.controls['pwd'].value || isSubmitted)"
            >
            <div class="arrow_box" *ngIf="focusPassword === true">
              {{'phnumbertext.title' | translate}}
            </div>
            <div class="arrow_box" *ngIf="focusPassword !== true">
              {{getErrorMessage('pwd',signUpStepOne)}}
            </div>
          </div>
          <!-- <div class="arrow_box_small passwrd_tooltip" *ngIf="shouldShowErrors('pwd',signUpStepOne)">{{getErrorMessage('pwd',signUpStepOne)}}</div> -->
        </div>
      </div>
    </div>
    <div class="row no-margin">
      <div class="custom_padding  col-sm-6 left_signup-12">
        <!-- firstName -->
        <div class="form-group" [ngClass]="getFormFiledClass('firstName',signUpStepOne, isSubmitted)">
          <div class="controls">
            <input type="text" autocomplete="given-name" formControlName="firstName" name="firstName" id="firstName"
              class="floatLabel form-control" (focus)="onFocusForElement('firstName')"
              (focusout)="onFocusOutForElement()" />
            <label for="firstName">{{ 'registrationStepOne.firstName' | translate }}</label>
          </div>
          <div class="arrow_box_small"
            *ngIf="getFormFiledClass('firstName',signUpStepOne, isSubmitted) && shouldShowErrors('firstName',signUpStepOne) && (signUpStepOne.controls['firstName'].value || isSubmitted)">
            {{getErrorMessage('firstName',signUpStepOne)}}</div>
        </div>
      </div>
      <div class="custom_padding  col-sm-6 left_signup-12">
        <!-- lastName -->
        <div class="form-group" [ngClass]="getFormFiledClass('lastName',signUpStepOne, isSubmitted)">
          <div class="controls">
            <input type="text" autocomplete="family-name" formControlName="lastName" name="lastName" id="lastName" class="floatLabel form-control"
              (focus)="onFocusForElement('lastName')" (focusout)="onFocusOutForElement()" />
            <label for="lastName">{{ 'registrationStepOne.lastName' | translate }}</label>
          </div>
          <div class="arrow_box_small"
            *ngIf="getFormFiledClass('lastName',signUpStepOne, isSubmitted) && shouldShowErrors('lastName',signUpStepOne) && (signUpStepOne.controls['lastName'].value || isSubmitted)">
            {{getErrorMessage('lastName',signUpStepOne)}}
          </div>
        </div>
      </div>
    </div>
    <div class="row no-margin">

      <div class="custom_padding  col-sm-3 left_signup-12">
        <!-- currency -->
        <!-- <div class="controls">
          <div class="name-field form-group" [ngClass]="getFormFiledClass('currencyCode',signUpStepOne)">
            <input formControlName="currencyCode" (focus)="onFocusForElement('currencyCode')" (focusout)="onFocusOutForElement()" class="floatLabel form-control currency-field" disabled>
          </div>
        </div> -->
      </div>
      <!-- phone -->
      <div class="custom_padding  col-sm-9 left_signup-12">
        <div class="form-group" [ngClass]="getFormFiledClass('phoneNumber',signUpStepOne, isSubmitted)">
          <div class="tel-number controls" id="phoneNumberFlag">
            <input class="coutry-code form-control floatLabel inputWithoutDecimal" (blur)="checkmobilereg('',false)"
              type="tel" autocomplete="tel-national" formControlName="phoneNumber" name="phone" (focus)="onFocusForElement('phoneNumber')"
              (focusout)="onFocusOutForElement()">
            <label  for="phoneNumberFlag" class="phone" [ngStyle]="{ 'opacity': (ipCountry === 'SE' && !toggleSwedenLable) ? '0.5' : ''}">{{ ipCountry == 'SE' && !toggleSwedenLable ? '731234567' : ('registrationStepOne.phoneNumber' | translate) }}</label>
          </div>
          <div class="arrow_box_small"
            *ngIf="getFormFiledClass('phoneNumber',signUpStepOne, isSubmitted) && shouldShowMblErrors('phoneNumber',signUpStepOne) && (signUpStepOne.controls['phoneNumber'].value || isSubmitted)">
            {{getErrorMessage('phoneNumber',signUpStepOne)}}</div>
        </div>
      </div>
    </div>
    <div class="clearfix"></div>
    <!-- termsNcondition -->
    <div class="form-group" [ngClass]="getFormFiledClass('emailAndMobileSubscribed',signUpStepOne, isSubmitted)">
      <div class="checkbox emailAndMobileSubscribed">
        <input type="checkbox" formControlName="emailAndMobileSubscribed"
          name="emailAndMobileSubscribed"
          [ngClass]="{'has-error':shouldShowErrors('emailAndMobileSubscribed',signUpStepOne)}"
          id="emailAndMobileSubscribed" (focus)="onFocusForElement('emailAndMobileSubscribed')"
          (focusout)="onFocusOutForElement()" />
        <label for="emailAndMobileSubscribed">
          <span>{{ 'registrationStepOne.byCreatingAnAccountiAgree' | translate }} <a
              routerLink="/{{langCode}}/page/terms-and-conditions"
              [target]="'_blank'">{{ 'registrationStepOne.TermsAndConditions' | translate }}</a>
            {{ 'registrationStepOne.and' | translate }} <a routerLink="/{{langCode}}/page/marketing-communication"
              [target]="'_blank'">{{ 'registrationStepOne.communicationRules' | translate }}</a>
            {{ 'registrationStepOne.duchExtensionJson'  | translate }}</span>
        </label>
      </div>
    </div>
    <div class="clearfix"></div>

  </div>
  <div class="clearfix"></div>

  <div class="mt30 text-center">
    <button type="button" class="submitBtn site-btn site-btn__primary site-btn--lg" id="stepOneId"
      (click)="checkmobilereg('stepOneId',true)">
      {{ 'registrationStepOne.continueBtn' | translate }}
    </button>
    <!-- <p class="form_footer_msg">{{ 'registrationStepOne.alreadyHaveAnAccount' | translate }}
      <a href="javascript:void(0);" (click)="moveToLogin()">{{ 'registrationStepOne.logInHere' | translate }}</a>
    </p> -->
  </div>
  <!-- removed mobile disbled button for consistency -->
  <!-- <div class="hidden-sm hidden-md hidden-lg form-btn" [ngClass]="getButtonDisabled(signUpStepOne) ? 'disabled' : ''">
    <button type="button" class="submitBtn site-btn site-btn__primary site-btn--lg" id="stepOneIdTab"
      (click)="checkmobilereg('stepOneIdTab',true)"
      [disabled]="getButtonDisabled(signUpStepOne)">{{ 'registrationStepOne.continueBtn' | translate }}</button>
  </div> -->
</form>